import { useService } from "../../../hook/useServices";
import BcIcon from "../Bc-Icon/Bc-icon";

const { REACT_APP_API_IP } = process.env;

const getIP = async () => {
  const response = await fetch(REACT_APP_API_IP as string);
  const data = await response.text();
  return data;
};

const fechaActual = new Date();
const anio = fechaActual.getFullYear();
const options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  hour12: "false",
  minute: "numeric",
  second: "numeric"
};

const BcFooter = () => {
  const ipQuery = useService("ip", getIP);
  const ip = ipQuery.data;

  return (
    <footer className="bc-footer bc-footer-white">
      <div className="bc-container">
        <div className="bc-footer-bottom bc-row">
          <div className="bc-footer-bottom-left bc-col-sm-8">
            <div className="bc-footer-bottom-left-icon">
              <BcIcon
                ariaLabel="isoBancolombia"
                iconName="isotipo-bancolombia"
              />
            </div>
            <div className="bc-footer-bottom-left-side bc-col-sm-11">
              <p>
                Copyright &copy; {anio} Grupo Bancolombia. Todos los derechos
                reservados.
              </p>
            </div>
          </div>
          <div className="bc-footer-bottom-right bc-col-sm-4">
            <div className="bc-footer-bottom-right-text">
              <p>
                Dirección IP: {ipQuery.isFetching ? '***.***.***.***' : `${ip}`}
              </p>
              <p>
                Conexión actual: {fechaActual.toLocaleString("es-ES", options as any)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BcFooter;
